import React from "react";

const HorizontalFooter =(props) =>{
  
    return (<a tabIndex="0" role="button" aria-label={props.item.LinkTitle} 
    title={props.item.LinkTitle}
    className={'horizontal-footer-item'} onClick={props.NavigationUrl}>
        <span className={'footer-item-child'}>{props.item.LinkTitle}</span></a>);
}
export default HorizontalFooter;